const locale = {
  TITLE_TIMEOUT: 'Something went wrong on our end',
  SUBTITLE_TIMEOUT:
    "Our servers hit an unexpected issue. We're already on it — this usually resolves itself in a few minutes.",
  RETRY_BUTTON_TIMEOUT: 'Try again',
};

export default locale;
